// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2EqUx","item":"PaymentsMobile_item__1FhXq","label":"PaymentsMobile_label__3Wc8k","amount":"PaymentsMobile_amount__Z1jwZ"};